import { baseAPI } from 'services/baseApi';

export const customBlockApis = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getCustomBlocksListing: builder.query({
      query: ({ user = '', programId = '', weekId = '', dayId = '', from, limit, requestId = '' }) => ({
        url: `custom-blocks/get-all?program=${programId}&user=${user}&week=${weekId}&day=${dayId}&requestId=${requestId}&from=${from}&limit=${limit}`,
        method: 'GET'
      }),
      providesTags: ['CUSTOM_BLOCKS']
    }),
    addCustomBlock: builder.mutation({
      query: (payload) => ({
        url: 'custom-blocks',
        method: 'POST',
        body: payload
      }),
      invalidatesTags: ['CUSTOM_BLOCKS']
    }),
    sortCustomBlockList: builder.mutation({
      query: (payload) => ({
        url: 'custom-blocks/update/sortNo',
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['CUSTOM_BLOCKS']
    }),
    updateCustomBlock: builder.mutation({
      query: ({ id, payload }) => ({
        url: 'custom-blocks/' + id,
        method: 'PUT',
        body: payload
      }),
      invalidatesTags: ['CUSTOM_BLOCKS']
    }),
    deleteCustomBlockPermanently: builder.mutation({
      query: ({ id }) => ({
        url: 'custom-blocks/permanent/' + id,
        method: 'DELETE'
      }),
      invalidatesTags: ['CUSTOM_BLOCKS']
    }),
    deleteCustomBlock: builder.mutation({
      query: ({ id }) => ({
        url: 'custom-blocks/' + id,
        method: 'DELETE'
      }),
      invalidatesTags: ['CUSTOM_BLOCKS']
    }),
    cloneCustomBlock: builder.mutation({
      query: ({ id }) => ({
        url: 'clone/custom-block/' + id,
        method: 'GET'
      }),
      invalidatesTags: ['CUSTOM_BLOCKS']
    }),
    restoreCustomBlock: builder.mutation({
      query: ({ id }) => ({
        url: 'custom-blocks/restore/' + id,
        method: 'PUT'
      }),
      invalidatesTags: ['CUSTOM_BLOCKS']
    }),
    getSingleCustomBlockDetails: builder.query({
      query: ({ id }) => ({
        url: `custom-blocks/${id}`,
        method: 'GET'
      }),
      providesTags: ['CUSTOM_BLOCKS']
    }),
    getCustomBlockMoveResult: builder.query({
      query: ({ moveId, userId, blockId }) => ({
        url: `move-result?moveId=${moveId}&userId=${userId}&blockId=${blockId}`,
        method: 'GET'
      }),
      providesTags: ['CUSTOM_BLOCK_MOVE_RESULT']
    }),
    getCustomBlockMoveResultByDayId: builder.query({
      query: ({ dayId, userId }) => ({
        url: `custom-blocks/get-move-results?dayId=${dayId}&userId=${userId}`,
        method: 'GET'
      })
    }),
    getMoveResultById: builder.query({
      query: ({ id }) => ({
        url: `move-result/${id}`,
        method: 'GET'
      })
    }),
    getLibraryForCustomBlocks: builder.query({
      query: ({ blockType, searchQuery = '', limit }) => ({
        url: `library?filterType=${blockType}&limit=${limit}&search=${searchQuery}`,
        method: 'GET'
      }),
      providesTags: ['LIBRARY_ITEMS']
    })
  })
});

export const {
  useGetCustomBlocksListingQuery,
  useSortCustomBlockListMutation,
  useAddCustomBlockMutation,
  useUpdateCustomBlockMutation,
  useDeleteCustomBlockPermanentlyMutation,
  useDeleteCustomBlockMutation,
  useCloneCustomBlockMutation,
  useRestoreCustomBlockMutation,
  useGetLibraryForCustomBlocksQuery,
  useGetCustomBlockMoveResultQuery,
  useGetCustomBlockMoveResultByDayIdQuery,
  useGetSingleCustomBlockDetailsQuery,
  useGetMoveResultByIdQuery
} = customBlockApis;
